import { toString } from 'lodash';

import * as layerOps from '../../api/Layers/layer-operations';
import * as styleOps from '../../api/Styles/style-operations';

import adaptURL from '../adapt-url';
import { getGeoJSONStyle } from '../geojson-layer-style';
import loadGeoJSONFromURL from '../load-geojson-from-url';
import loadStyleFromURL from '../load-style-from-url';

import customTopoJSON from './customTopoJSON';

/**
 * Builds the TopoJSON layer.
 *
 * @async
 * @param {object} arg - The object argument.
 * @param {object} arg.layer - The layer object.
 * @param {object} arg.style - The style object.
 * @param {boolean} [arg.isPartOfMap=false] - Flag that is true if layer is part of a map.
 * @param {number} [arg.zIndex=400] - The zIndex for the layer.
 * @returns {Promise<object>} The leaflet layer to add to the map with the url and the options.
 */
const buildTopoJSONLayer = async ({ layer, style, isPartOfMap = false, zIndex = 400 }) => {
  let geojsonFile = '';
  let layerToDraw = '';
  let styleOptions = {};
  let options = {};
  let customStyleObject = {};

  try {
    const url = adaptURL(layerOps.getURL(layer));
    geojsonFile = await loadGeoJSONFromURL(url);

    if (styleOps.isCustom(style))
      customStyleObject = await loadStyleFromURL({
        url: adaptURL(styleOps.getStyleURL(style)),
        layer
      });

    if (isPartOfMap) {
      styleOptions = await getGeoJSONStyle({
        style,
        layer,
        pane: toString(zIndex),
        customStyleObject
      });
      options = {
        ...styleOptions,
        attribution: layerOps.getAttribution(layer),
        pane: toString(zIndex),
        maxZoom: layerOps.getMaxZoom(layer)
      };
    } else {
      styleOptions = await getGeoJSONStyle({ style, layer, customStyleObject });
      options = {
        ...styleOptions,
        attribution: layerOps.getAttribution(layer),
        maxZoom: layerOps.getMaxZoom(layer)
      };
    }

    layerToDraw = customTopoJSON(geojsonFile, options);
    return layerToDraw;
  } catch (error) {
    console.error(error);
    throw new Error(error.message);
  }
};

export default buildTopoJSONLayer;
